<h1 class="page-title">Services</h1>

<div class="jobs-top-wrapper" *ngIf="hasInvoicingPermissions">
  <div class="jobs-figures">
    <div class="jobs-figures-inner">
      <div
              class="jobs-figure not-invoiced-tab"
              (click)="filterJobs('Not_Invoiced')"
              [ngClass]="filterSelection === 'Not_Invoiced' ? 'not-invoiced-selected' : null"
      >
        <div class="filter-icon">
          <svg
                  width="60"
                  height="60"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
          >
            <path fill="#319bbe" stroke="#FFFFFF" stroke-width="0"
                  d="M14.6341 30C10.7252 30 7.05023 28.4398 4.2862 25.6066C1.52218 22.7735 0 19.0066 0 15C0 10.9934 1.52224 7.22654 4.2862 4.39336C7.05017 1.56018 10.7252 0 14.6341 0C18.5431 0 22.2181 1.56023 24.9821 4.39336C27.7461 7.22648 29.2683 10.9934 29.2683 15C29.2683 19.0066 27.7461 22.7735 24.9821 25.6066C22.2181 28.4398 18.5431 30 14.6341 30ZM14.6341 1.875C7.57351 1.875 1.82927 7.76285 1.82927 15C1.82927 22.2371 7.57351 28.125 14.6341 28.125C21.6948 28.125 27.439 22.2371 27.439 15C27.439 7.76285 21.6948 1.875 14.6341 1.875Z"/>
            <path fill="#319bbe" stroke="#FFFFFF" stroke-width="0"
                  d="M14.6342 14.0625C13.3733 14.0625 12.3476 13.0111 12.3476 11.7188C12.3476 10.4264 13.3733 9.375 14.6342 9.375C15.895 9.375 16.9207 10.4264 16.9207 11.7188C16.9207 12.2365 17.3302 12.6562 17.8354 12.6562C18.3405 12.6562 18.75 12.2365 18.75 11.7188C18.75 9.71479 17.3793 8.03391 15.5488 7.60629V6.5625C15.5488 6.04477 15.1393 5.625 14.6342 5.625C14.129 5.625 13.7195 6.04477 13.7195 6.5625V7.60629C11.889 8.03391 10.5183 9.71479 10.5183 11.7188C10.5183 14.045 12.3647 15.9375 14.6342 15.9375C15.895 15.9375 16.9207 16.9889 16.9207 18.2812C16.9207 19.5736 15.895 20.625 14.6342 20.625C13.3733 20.625 12.3476 19.5736 12.3476 18.2812C12.3476 17.7635 11.9381 17.3438 11.4329 17.3438C10.9278 17.3438 10.5183 17.7635 10.5183 18.2812C10.5183 20.2852 11.889 21.9661 13.7195 22.3937V23.4375C13.7195 23.9552 14.129 24.375 14.6342 24.375C15.1393 24.375 15.5488 23.9552 15.5488 23.4375V22.3937C17.3793 21.9661 18.75 20.2852 18.75 18.2812C18.75 15.955 16.9037 14.0625 14.6342 14.0625Z"/>
          </svg>
        </div>
        <div class="filter-info">
          <span>Not Invoiced</span>
          <h4>{{notInvoicedCounterValue}}</h4>
        </div>
      </div>
      <div
              class="jobs-figure not-invoiced-tab not-luxengine-tab"
              (click)="filterJobs('Include_LuxEngine')"
              [ngClass]="includeLuxEngine ? 'not-invoiced-selected' : null"
      >
        <div class="filter-icon">
          <svg-icon src="/assets/icons/jobs/ai-only.svg"></svg-icon>
        </div>
        <div class="filter-info">
          <span>Include ZeroTouch</span>
          <h4>{{includeLuxEngineCounterValue}}</h4>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="content-wrapper table-wrapper jobs-table-wrapper">
  <prism-jobs-table
          *ngIf="(services$ | async)?.length >= 1 || (servicesLoading$ | async)"
          [servicesCount]="tableServicesCount"
          [pageIndex]="pageIndex"
          (paginationEvent)="fetchServices($event)"
          (confirmationSuccess)="onConfirmationSuccess()"
          [setServices]="(services$ | async)">
  </prism-jobs-table>

  <div class="jobs-list-empty" *ngIf="(services$ | async)?.length <= 0  && !(servicesLoading$ | async)">
    <h5 *ngIf="filterSelection; else noServices">No services match this filter...</h5>
    <ng-template #noServices>
      <h5>No services have been added...</h5>
    </ng-template>
  </div>
</div>
